module.exports = "<div class=\"icon\" [class.button]=\"!!button\" [style.width]=\"width\" [style.height]=\"height\" [innerHTML]=\"svgContent\">\n</div>"